function Or(o, r, t) {
  const s = "virtual:storyblok-init", i = "\0" + s;
  return {
    name: "vite-plugin-storyblok-init",
    async resolveId(l) {
      if (l === s)
        return i;
    },
    async load(l) {
      if (l === i)
        return `
          import { storyblokInit, apiPlugin } from "@storyblok/js";
          const { storyblokApi } = storyblokInit({
            accessToken: "${o}",
            use: ${r ? "[]" : "[apiPlugin]"},
            apiOptions: ${JSON.stringify(t)},
          });
          export const storyblokApiInstance = storyblokApi;  
        `;
    }
  };
}
const Cr = /[\p{Lu}]/u, jr = /[\p{Ll}]/u, Ne = /^[\p{Lu}](?![\p{Lu}])/gu, Ge = /([\p{Alpha}\p{N}_]|$)/u, fe = /[_.\- ]+/, xr = new RegExp("^" + fe.source), ze = new RegExp(fe.source + Ge.source, "gu"), Le = new RegExp("\\d+" + Ge.source, "gu"), $r = (o, r, t, s) => {
  let i = !1, l = !1, u = !1, f = !1;
  for (let p = 0; p < o.length; p++) {
    const y = o[p];
    f = p > 2 ? o[p - 3] === "-" : !0, i && Cr.test(y) ? (o = o.slice(0, p) + "-" + o.slice(p), i = !1, u = l, l = !0, p++) : l && u && jr.test(y) && (!f || s) ? (o = o.slice(0, p - 1) + "-" + o.slice(p - 1), u = l, l = !1, i = !0) : (i = r(y) === y && t(y) !== y, u = l, l = t(y) === y && r(y) !== y);
  }
  return o;
}, Er = (o, r) => (Ne.lastIndex = 0, o.replaceAll(Ne, (t) => r(t))), Rr = (o, r) => (ze.lastIndex = 0, Le.lastIndex = 0, o.replaceAll(Le, (t, s, i) => ["_", "-"].includes(o.charAt(i + t.length)) ? t : r(t)).replaceAll(ze, (t, s) => r(s)));
function De(o, r) {
  if (!(typeof o == "string" || Array.isArray(o)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (r = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...r
  }, Array.isArray(o) ? o = o.map((l) => l.trim()).filter((l) => l.length).join("-") : o = o.trim(), o.length === 0)
    return "";
  const t = r.locale === !1 ? (l) => l.toLowerCase() : (l) => l.toLocaleLowerCase(r.locale), s = r.locale === !1 ? (l) => l.toUpperCase() : (l) => l.toLocaleUpperCase(r.locale);
  return o.length === 1 ? fe.test(o) ? "" : r.pascalCase ? s(o) : t(o) : (o !== t(o) && (o = $r(o, t, s, r.preserveConsecutiveUppercase)), o = o.replace(xr, ""), o = r.preserveConsecutiveUppercase ? Er(o, t) : t(o), r.pascalCase && (o = s(o.charAt(0)) + o.slice(1)), Rr(o, s));
}
function Pr(o, r, t, s) {
  const i = "virtual:storyblok-components", l = "\0" + i;
  return {
    name: "vite-plugin-storyblok-components",
    async resolveId(u) {
      if (u === i)
        return l;
    },
    async load(u) {
      if (u === l) {
        const f = [], p = [];
        for await (const [_, k] of Object.entries(r)) {
          const A = await this.resolve(
            "/" + o + "/" + k + ".astro"
          );
          if (A)
            f.push(`import ${De(_)} from "${A.id}"`);
          else if (t)
            p.push(_);
          else
            throw new Error(
              `Component could not be found for blok "${_}"! Does "${"/" + o + "/" + k}.astro" exist?`
            );
        }
        let y = "";
        if (t)
          if (y = ",FallbackComponent", s) {
            const _ = await this.resolve(
              "/" + o + "/" + s + ".astro"
            );
            if (!_)
              throw new Error(
                `Custom fallback component could not be found. Does "${"/" + o + "/" + s}.astro" exist?`
              );
            f.push(
              `import FallbackComponent from "${_.id}"`
            );
          } else
            f.push(
              "import FallbackComponent from '@storyblok/astro/FallbackComponent.astro'"
            );
        if (Object.values(r).length)
          return `${f.join(";")};export default {${Object.keys(r).filter((_) => !p.includes(_)).map((_) => De(_)).join(",")}${y}}`;
        if (t)
          return `${f[0]}; export default {${y.replace(",", "")}}`;
        throw new Error(
          `Currently, no Storyblok components are registered in astro.config.mjs.
Please register your components or enable the fallback component.
Detailed information can be found here: https://github.com/storyblok/storyblok-astro`
        );
      }
    }
  };
}
function Mr(o) {
  const r = "virtual:storyblok-options", t = "\0" + r;
  return {
    name: "vite-plugin-storyblok-options",
    async resolveId(s) {
      if (s === r)
        return t;
    },
    async load(s) {
      if (s === t)
        return `export default ${JSON.stringify(o)}`;
    }
  };
}
let Ue = !1;
const Be = [], Nr = (o) => new Promise((r, t) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (i) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    Ue ? i() : Be.push(i);
  }, document.getElementById("storyblok-javascript-bridge"))) return;
  const s = document.createElement("script");
  s.async = !0, s.src = o, s.id = "storyblok-javascript-bridge", s.onerror = (i) => t(i), s.onload = (i) => {
    Be.forEach((l) => l()), Ue = !0, r(i);
  }, document.getElementsByTagName("head")[0].appendChild(s);
});
var zr = Object.defineProperty, Lr = (o, r, t) => r in o ? zr(o, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[r] = t, S = (o, r, t) => Lr(o, typeof r != "symbol" ? r + "" : r, t);
class Dr {
  constructor() {
    S(this, "isCDNUrl", (r = "") => r.indexOf("/cdn/") > -1), S(this, "getOptionsPage", (r, t = 25, s = 1) => ({
      ...r,
      per_page: t,
      page: s
    })), S(this, "delay", (r) => new Promise((t) => setTimeout(t, r))), S(this, "arrayFrom", (r = 0, t) => [...Array(r)].map(t)), S(this, "range", (r = 0, t = r) => {
      const s = Math.abs(t - r) || 0, i = r < t ? 1 : -1;
      return this.arrayFrom(s, (l, u) => u * i + r);
    }), S(this, "asyncMap", async (r, t) => Promise.all(r.map(t))), S(this, "flatMap", (r = [], t) => r.map(t).reduce((s, i) => [...s, ...i], [])), S(this, "escapeHTML", function(r) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, s = /[&<>"']/g, i = RegExp(s.source);
      return r && i.test(r) ? r.replace(s, (l) => t[l]) : r;
    });
  }
  /**
   * @method stringify
   * @param  {Object} params
   * @param  {String} prefix
   * @param  {Boolean} isArray
   * @return {String} Stringified object
   */
  stringify(r, t, s) {
    const i = [];
    for (const l in r) {
      if (!Object.prototype.hasOwnProperty.call(r, l))
        continue;
      const u = r[l], f = s ? "" : encodeURIComponent(l);
      let p;
      typeof u == "object" ? p = this.stringify(
        u,
        t ? t + encodeURIComponent("[" + f + "]") : f,
        Array.isArray(u)
      ) : p = (t ? t + encodeURIComponent("[" + f + "]") : f) + "=" + encodeURIComponent(u), i.push(p);
    }
    return i.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {String} regionCode region code, could be eu, us, cn, ap or ca
   * @return {String} The base URL of the region
   */
  getRegionURL(r) {
    const t = "api.storyblok.com", s = "api-us.storyblok.com", i = "app.storyblokchina.cn", l = "api-ap.storyblok.com", u = "api-ca.storyblok.com";
    switch (r) {
      case "us":
        return s;
      case "cn":
        return i;
      case "ap":
        return l;
      case "ca":
        return u;
      default:
        return t;
    }
  }
}
const Ur = function(o, r) {
  const t = {};
  for (const s in o) {
    const i = o[s];
    r.indexOf(s) > -1 && i !== null && (t[s] = i);
  }
  return t;
}, Br = (o) => o === "email", Fr = () => ({
  singleTag: "hr"
}), Hr = () => ({
  tag: "blockquote"
}), qr = () => ({
  tag: "ul"
}), Gr = (o) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: o.attrs
    }
  ]
}), Jr = () => ({
  singleTag: "br"
}), Kr = (o) => ({
  tag: `h${o.attrs.level}`
}), Wr = (o) => ({
  singleTag: [
    {
      tag: "img",
      attrs: Ur(o.attrs, ["src", "alt", "title"])
    }
  ]
}), Xr = () => ({
  tag: "li"
}), Yr = () => ({
  tag: "ol"
}), Zr = () => ({
  tag: "p"
}), Qr = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": o.attrs.name,
        emoji: o.attrs.emoji
      }
    }
  ]
}), Vr = () => ({
  tag: "b"
}), en = () => ({
  tag: "s"
}), tn = () => ({
  tag: "u"
}), rn = () => ({
  tag: "strong"
}), nn = () => ({
  tag: "code"
}), on = () => ({
  tag: "i"
}), an = (o) => {
  if (!o.attrs)
    return {
      tag: ""
    };
  const r = new Dr().escapeHTML, t = { ...o.attrs }, { linktype: s = "url" } = o.attrs;
  if (delete t.linktype, t.href && (t.href = r(o.attrs.href || "")), Br(s) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const i in t.custom)
      t[i] = t.custom[i];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, sn = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), ln = () => ({
  tag: "sub"
}), cn = () => ({
  tag: "sup"
}), un = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), fn = (o) => {
  var r;
  return (r = o.attrs) != null && r.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${o.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, dn = (o) => {
  var r;
  return (r = o.attrs) != null && r.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${o.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, pn = {
  nodes: {
    horizontal_rule: Fr,
    blockquote: Hr,
    bullet_list: qr,
    code_block: Gr,
    hard_break: Jr,
    heading: Kr,
    image: Wr,
    list_item: Xr,
    ordered_list: Yr,
    paragraph: Zr,
    emoji: Qr
  },
  marks: {
    bold: Vr,
    strike: en,
    underline: tn,
    strong: rn,
    code: nn,
    italic: on,
    link: an,
    styled: sn,
    subscript: ln,
    superscript: cn,
    anchor: un,
    highlight: fn,
    textStyle: dn
  }
}, gn = function(o) {
  const r = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, s = RegExp(t.source);
  return o && s.test(o) ? o.replace(t, (i) => r[i]) : o;
};
let Fe = !1;
class hn {
  constructor(r) {
    S(this, "marks"), S(this, "nodes"), r || (r = pn), this.marks = r.marks || [], this.nodes = r.nodes || [];
  }
  addNode(r, t) {
    this.nodes[r] = t;
  }
  addMark(r, t) {
    this.marks[r] = t;
  }
  render(r, t = { optimizeImages: !1 }, s = !0) {
    if (!Fe && s && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), Fe = !0), r && r.content && Array.isArray(r.content)) {
      let i = "";
      return r.content.forEach((l) => {
        i += this.renderNode(l);
      }), t.optimizeImages ? this.optimizeImages(i, t.optimizeImages) : i;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
			The "content" field must be an array of nodes as the type ISbRichtext.
			ISbRichtext:
				content?: ISbRichtext[]
				marks?: ISbRichtext[]
				attrs?: any
				text?: string
				type: string
				
				Example:
				{
					content: [
						{
							content: [
								{
									text: 'Hello World',
									type: 'text'
								}
							],
							type: 'paragraph'
						}
					],
					type: 'doc'
				}`
    ), "";
  }
  optimizeImages(r, t) {
    let s = 0, i = 0, l = "", u = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (l += `width="${t.width}" `, s = t.width), typeof t.height == "number" && t.height > 0 && (l += `height="${t.height}" `, i = t.height), (t.loading === "lazy" || t.loading === "eager") && (l += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (l += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (u += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (u += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-Fa-f]{6}/g) || t.filters.fill === "transparent") && (u += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (u += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (u += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (u += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (u += `:rotate(${t.filters.rotate})`), u.length > 0 && (u = "/filters" + u))), l.length > 0 && (r = r.replace(/<img/g, `<img ${l.trim()}`));
    const f = s > 0 || i > 0 || u.length > 0 ? `${s}x${i}${u}` : "";
    return r = r.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${f}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (r = r.replace(/<img.*?src=["|'](.*?)["|']/g, (p) => {
      var y, _;
      const k = p.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g
      );
      if (k && k.length > 0) {
        const A = {
          srcset: (y = t.srcset) == null ? void 0 : y.map((w) => {
            if (typeof w == "number")
              return `//${k}/m/${w}x0${u} ${w}w`;
            if (typeof w == "object" && w.length === 2) {
              let M = 0, F = 0;
              return typeof w[0] == "number" && (M = w[0]), typeof w[1] == "number" && (F = w[1]), `//${k}/m/${M}x${F}${u} ${M}w`;
            }
          }).join(", "),
          sizes: (_ = t.sizes) == null ? void 0 : _.map((w) => w).join(", ")
        };
        let O = "";
        return A.srcset && (O += `srcset="${A.srcset}" `), A.sizes && (O += `sizes="${A.sizes}" `), p.replace(/<img/g, `<img ${O.trim()}`);
      }
      return p;
    })), r;
  }
  renderNode(r) {
    const t = [];
    r.marks && r.marks.forEach((i) => {
      const l = this.getMatchingMark(i);
      l && l.tag !== "" && t.push(this.renderOpeningTag(l.tag));
    });
    const s = this.getMatchingNode(r);
    return s && s.tag && t.push(this.renderOpeningTag(s.tag)), r.content ? r.content.forEach((i) => {
      t.push(this.renderNode(i));
    }) : r.text ? t.push(gn(r.text)) : s && s.singleTag ? t.push(this.renderTag(s.singleTag, " /")) : s && s.html ? t.push(s.html) : r.type === "emoji" && t.push(this.renderEmoji(r)), s && s.tag && t.push(this.renderClosingTag(s.tag)), r.marks && r.marks.slice(0).reverse().forEach((i) => {
      const l = this.getMatchingMark(i);
      l && l.tag !== "" && t.push(this.renderClosingTag(l.tag));
    }), t.join("");
  }
  renderTag(r, t) {
    return r.constructor === String ? `<${r}${t}>` : r.map((s) => {
      if (s.constructor === String)
        return `<${s}${t}>`;
      {
        let i = `<${s.tag}`;
        if (s.attrs) {
          for (const l in s.attrs)
            if (Object.prototype.hasOwnProperty.call(s.attrs, l)) {
              const u = s.attrs[l];
              u !== null && (i += ` ${l}="${u}"`);
            }
        }
        return `${i}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(r) {
    return this.renderTag(r, "");
  }
  renderClosingTag(r) {
    return r.constructor === String ? `</${r}>` : r.slice(0).reverse().map((t) => t.constructor === String ? `</${t}>` : `</${t.tag}>`).join("");
  }
  getMatchingNode(r) {
    const t = this.nodes[r.type];
    if (typeof t == "function")
      return t(r);
  }
  getMatchingMark(r) {
    const t = this.marks[r.type];
    if (typeof t == "function")
      return t(r);
  }
  renderEmoji(r) {
    if (r.attrs.emoji)
      return r.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: r.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
const bn = hn, $n = (o) => {
  if (typeof o != "object" || typeof o._editable > "u")
    return {};
  try {
    const r = JSON.parse(
      o._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return r ? {
      "data-blok-c": JSON.stringify(r),
      "data-blok-uid": r.id + "-" + r.uid
    } : {};
  } catch {
    return {};
  }
};
let yn, mn = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const vn = (o, r) => {
  o.addNode("blok", (t) => {
    let s = "";
    return t.attrs.body.forEach((i) => {
      s += r(i.component, i);
    }), {
      html: s
    };
  });
}, _n = (o) => !o || !(o != null && o.content.some((r) => r.content || r.type === "blok" || r.type === "horizontal_rule")), wn = (o, r, t) => {
  let s = t || yn;
  if (!s) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return _n(o) ? "" : (r && (s = new bn(r.schema), r.resolver && vn(s, r.resolver)), s.render(o, {}, !1));
}, En = () => Nr(mn);
function Tn(o) {
  let r = {
    resolveRelations: []
  };
  function t(s) {
    s && Array.isArray(r.resolveRelations) && r.resolveRelations.push(
      ...Array.isArray(s) ? s : [s]
    );
  }
  for (const s of o)
    if (s.options) {
      const { apiOptions: i, bridgeOptions: l } = s.options;
      if (t(i == null ? void 0 : i.resolve_relations), l) {
        const { resolveRelations: u, ...f } = l;
        t(u), Object.assign(r, f);
      }
    }
  return r.resolveRelations = [...new Set(r.resolveRelations)], r;
}
var Z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kn(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var Q = { exports: {} };
Q.exports;
(function(o, r) {
  var t = 200, s = "__lodash_hash_undefined__", i = 800, l = 16, u = 9007199254740991, f = "[object Arguments]", p = "[object Array]", y = "[object AsyncFunction]", _ = "[object Boolean]", k = "[object Date]", A = "[object Error]", O = "[object Function]", w = "[object GeneratorFunction]", M = "[object Map]", F = "[object Number]", Je = "[object Null]", de = "[object Object]", Ke = "[object Proxy]", We = "[object RegExp]", Xe = "[object Set]", Ye = "[object String]", Ze = "[object Undefined]", Qe = "[object WeakMap]", Ve = "[object ArrayBuffer]", et = "[object DataView]", tt = "[object Float32Array]", rt = "[object Float64Array]", nt = "[object Int8Array]", ot = "[object Int16Array]", at = "[object Int32Array]", st = "[object Uint8Array]", it = "[object Uint8ClampedArray]", lt = "[object Uint16Array]", ct = "[object Uint32Array]", ut = /[\\^$.*+?()[\]{}|]/g, ft = /^\[object .+?Constructor\]$/, dt = /^(?:0|[1-9]\d*)$/, b = {};
  b[tt] = b[rt] = b[nt] = b[ot] = b[at] = b[st] = b[it] = b[lt] = b[ct] = !0, b[f] = b[p] = b[Ve] = b[_] = b[et] = b[k] = b[A] = b[O] = b[M] = b[F] = b[de] = b[We] = b[Xe] = b[Ye] = b[Qe] = !1;
  var pe = typeof Z == "object" && Z && Z.Object === Object && Z, pt = typeof self == "object" && self && self.Object === Object && self, N = pe || pt || Function("return this")(), ge = r && !r.nodeType && r, z = ge && !0 && o && !o.nodeType && o, he = z && z.exports === ge, V = he && pe.process, be = function() {
    try {
      var e = z && z.require && z.require("util").types;
      return e || V && V.binding && V.binding("util");
    } catch {
    }
  }(), ye = be && be.isTypedArray;
  function gt(e, n, a) {
    switch (a.length) {
      case 0:
        return e.call(n);
      case 1:
        return e.call(n, a[0]);
      case 2:
        return e.call(n, a[0], a[1]);
      case 3:
        return e.call(n, a[0], a[1], a[2]);
    }
    return e.apply(n, a);
  }
  function ht(e, n) {
    for (var a = -1, c = Array(e); ++a < e; )
      c[a] = n(a);
    return c;
  }
  function bt(e) {
    return function(n) {
      return e(n);
    };
  }
  function yt(e, n) {
    return e == null ? void 0 : e[n];
  }
  function mt(e, n) {
    return function(a) {
      return e(n(a));
    };
  }
  var vt = Array.prototype, _t = Function.prototype, H = Object.prototype, ee = N["__core-js_shared__"], q = _t.toString, j = H.hasOwnProperty, me = function() {
    var e = /[^.]+$/.exec(ee && ee.keys && ee.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), ve = H.toString, wt = q.call(Object), Tt = RegExp(
    "^" + q.call(j).replace(ut, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), G = he ? N.Buffer : void 0, _e = N.Symbol, we = N.Uint8Array;
  G && G.allocUnsafe;
  var Te = mt(Object.getPrototypeOf, Object), ke = Object.create, kt = H.propertyIsEnumerable, At = vt.splice, x = _e ? _e.toStringTag : void 0, J = function() {
    try {
      var e = ne(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch {
    }
  }(), It = G ? G.isBuffer : void 0, Ae = Math.max, St = Date.now, Ie = ne(N, "Map"), L = ne(Object, "create"), Ot = /* @__PURE__ */ function() {
    function e() {
    }
    return function(n) {
      if (!E(n))
        return {};
      if (ke)
        return ke(n);
      e.prototype = n;
      var a = new e();
      return e.prototype = void 0, a;
    };
  }();
  function $(e) {
    var n = -1, a = e == null ? 0 : e.length;
    for (this.clear(); ++n < a; ) {
      var c = e[n];
      this.set(c[0], c[1]);
    }
  }
  function Ct() {
    this.__data__ = L ? L(null) : {}, this.size = 0;
  }
  function jt(e) {
    var n = this.has(e) && delete this.__data__[e];
    return this.size -= n ? 1 : 0, n;
  }
  function xt(e) {
    var n = this.__data__;
    if (L) {
      var a = n[e];
      return a === s ? void 0 : a;
    }
    return j.call(n, e) ? n[e] : void 0;
  }
  function $t(e) {
    var n = this.__data__;
    return L ? n[e] !== void 0 : j.call(n, e);
  }
  function Et(e, n) {
    var a = this.__data__;
    return this.size += this.has(e) ? 0 : 1, a[e] = L && n === void 0 ? s : n, this;
  }
  $.prototype.clear = Ct, $.prototype.delete = jt, $.prototype.get = xt, $.prototype.has = $t, $.prototype.set = Et;
  function C(e) {
    var n = -1, a = e == null ? 0 : e.length;
    for (this.clear(); ++n < a; ) {
      var c = e[n];
      this.set(c[0], c[1]);
    }
  }
  function Rt() {
    this.__data__ = [], this.size = 0;
  }
  function Pt(e) {
    var n = this.__data__, a = K(n, e);
    if (a < 0)
      return !1;
    var c = n.length - 1;
    return a == c ? n.pop() : At.call(n, a, 1), --this.size, !0;
  }
  function Mt(e) {
    var n = this.__data__, a = K(n, e);
    return a < 0 ? void 0 : n[a][1];
  }
  function Nt(e) {
    return K(this.__data__, e) > -1;
  }
  function zt(e, n) {
    var a = this.__data__, c = K(a, e);
    return c < 0 ? (++this.size, a.push([e, n])) : a[c][1] = n, this;
  }
  C.prototype.clear = Rt, C.prototype.delete = Pt, C.prototype.get = Mt, C.prototype.has = Nt, C.prototype.set = zt;
  function R(e) {
    var n = -1, a = e == null ? 0 : e.length;
    for (this.clear(); ++n < a; ) {
      var c = e[n];
      this.set(c[0], c[1]);
    }
  }
  function Lt() {
    this.size = 0, this.__data__ = {
      hash: new $(),
      map: new (Ie || C)(),
      string: new $()
    };
  }
  function Dt(e) {
    var n = X(this, e).delete(e);
    return this.size -= n ? 1 : 0, n;
  }
  function Ut(e) {
    return X(this, e).get(e);
  }
  function Bt(e) {
    return X(this, e).has(e);
  }
  function Ft(e, n) {
    var a = X(this, e), c = a.size;
    return a.set(e, n), this.size += a.size == c ? 0 : 1, this;
  }
  R.prototype.clear = Lt, R.prototype.delete = Dt, R.prototype.get = Ut, R.prototype.has = Bt, R.prototype.set = Ft;
  function P(e) {
    var n = this.__data__ = new C(e);
    this.size = n.size;
  }
  function Ht() {
    this.__data__ = new C(), this.size = 0;
  }
  function qt(e) {
    var n = this.__data__, a = n.delete(e);
    return this.size = n.size, a;
  }
  function Gt(e) {
    return this.__data__.get(e);
  }
  function Jt(e) {
    return this.__data__.has(e);
  }
  function Kt(e, n) {
    var a = this.__data__;
    if (a instanceof C) {
      var c = a.__data__;
      if (!Ie || c.length < t - 1)
        return c.push([e, n]), this.size = ++a.size, this;
      a = this.__data__ = new R(c);
    }
    return a.set(e, n), this.size = a.size, this;
  }
  P.prototype.clear = Ht, P.prototype.delete = qt, P.prototype.get = Gt, P.prototype.has = Jt, P.prototype.set = Kt;
  function Wt(e, n) {
    var a = se(e), c = !a && ae(e), d = !a && !c && xe(e), h = !a && !c && !d && Ee(e), m = a || c || d || h, g = m ? ht(e.length, String) : [], v = g.length;
    for (var I in e)
      m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (I == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (I == "offset" || I == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      h && (I == "buffer" || I == "byteLength" || I == "byteOffset") || // Skip index properties.
      Ce(I, v)) || g.push(I);
    return g;
  }
  function te(e, n, a) {
    (a !== void 0 && !Y(e[n], a) || a === void 0 && !(n in e)) && re(e, n, a);
  }
  function Xt(e, n, a) {
    var c = e[n];
    (!(j.call(e, n) && Y(c, a)) || a === void 0 && !(n in e)) && re(e, n, a);
  }
  function K(e, n) {
    for (var a = e.length; a--; )
      if (Y(e[a][0], n))
        return a;
    return -1;
  }
  function re(e, n, a) {
    n == "__proto__" && J ? J(e, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : e[n] = a;
  }
  var Yt = cr();
  function W(e) {
    return e == null ? e === void 0 ? Ze : Je : x && x in Object(e) ? ur(e) : br(e);
  }
  function Se(e) {
    return D(e) && W(e) == f;
  }
  function Zt(e) {
    if (!E(e) || gr(e))
      return !1;
    var n = le(e) ? Tt : ft;
    return n.test(_r(e));
  }
  function Qt(e) {
    return D(e) && $e(e.length) && !!b[W(e)];
  }
  function Vt(e) {
    if (!E(e))
      return hr(e);
    var n = je(e), a = [];
    for (var c in e)
      c == "constructor" && (n || !j.call(e, c)) || a.push(c);
    return a;
  }
  function Oe(e, n, a, c, d) {
    e !== n && Yt(n, function(h, m) {
      if (d || (d = new P()), E(h))
        er(e, n, m, a, Oe, c, d);
      else {
        var g = c ? c(oe(e, m), h, m + "", e, n, d) : void 0;
        g === void 0 && (g = h), te(e, m, g);
      }
    }, Re);
  }
  function er(e, n, a, c, d, h, m) {
    var g = oe(e, a), v = oe(n, a), I = m.get(v);
    if (I) {
      te(e, a, I);
      return;
    }
    var T = h ? h(g, v, a + "", e, n, m) : void 0, U = T === void 0;
    if (U) {
      var ce = se(v), ue = !ce && xe(v), Me = !ce && !ue && Ee(v);
      T = v, ce || ue || Me ? se(g) ? T = g : wr(g) ? T = sr(g) : ue ? (U = !1, T = nr(v)) : Me ? (U = !1, T = ar(v)) : T = [] : Tr(v) || ae(v) ? (T = g, ae(g) ? T = kr(g) : (!E(g) || le(g)) && (T = fr(v))) : U = !1;
    }
    U && (m.set(v, T), d(T, v, c, h, m), m.delete(v)), te(e, a, T);
  }
  function tr(e, n) {
    return mr(yr(e, n, Pe), e + "");
  }
  var rr = J ? function(e, n) {
    return J(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Ir(n),
      writable: !0
    });
  } : Pe;
  function nr(e, n) {
    return e.slice();
  }
  function or(e) {
    var n = new e.constructor(e.byteLength);
    return new we(n).set(new we(e)), n;
  }
  function ar(e, n) {
    var a = or(e.buffer);
    return new e.constructor(a, e.byteOffset, e.length);
  }
  function sr(e, n) {
    var a = -1, c = e.length;
    for (n || (n = Array(c)); ++a < c; )
      n[a] = e[a];
    return n;
  }
  function ir(e, n, a, c) {
    var d = !a;
    a || (a = {});
    for (var h = -1, m = n.length; ++h < m; ) {
      var g = n[h], v = void 0;
      v === void 0 && (v = e[g]), d ? re(a, g, v) : Xt(a, g, v);
    }
    return a;
  }
  function lr(e) {
    return tr(function(n, a) {
      var c = -1, d = a.length, h = d > 1 ? a[d - 1] : void 0, m = d > 2 ? a[2] : void 0;
      for (h = e.length > 3 && typeof h == "function" ? (d--, h) : void 0, m && dr(a[0], a[1], m) && (h = d < 3 ? void 0 : h, d = 1), n = Object(n); ++c < d; ) {
        var g = a[c];
        g && e(n, g, c, h);
      }
      return n;
    });
  }
  function cr(e) {
    return function(n, a, c) {
      for (var d = -1, h = Object(n), m = c(n), g = m.length; g--; ) {
        var v = m[++d];
        if (a(h[v], v, h) === !1)
          break;
      }
      return n;
    };
  }
  function X(e, n) {
    var a = e.__data__;
    return pr(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  function ne(e, n) {
    var a = yt(e, n);
    return Zt(a) ? a : void 0;
  }
  function ur(e) {
    var n = j.call(e, x), a = e[x];
    try {
      e[x] = void 0;
      var c = !0;
    } catch {
    }
    var d = ve.call(e);
    return c && (n ? e[x] = a : delete e[x]), d;
  }
  function fr(e) {
    return typeof e.constructor == "function" && !je(e) ? Ot(Te(e)) : {};
  }
  function Ce(e, n) {
    var a = typeof e;
    return n = n ?? u, !!n && (a == "number" || a != "symbol" && dt.test(e)) && e > -1 && e % 1 == 0 && e < n;
  }
  function dr(e, n, a) {
    if (!E(a))
      return !1;
    var c = typeof n;
    return (c == "number" ? ie(a) && Ce(n, a.length) : c == "string" && n in a) ? Y(a[n], e) : !1;
  }
  function pr(e) {
    var n = typeof e;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
  }
  function gr(e) {
    return !!me && me in e;
  }
  function je(e) {
    var n = e && e.constructor, a = typeof n == "function" && n.prototype || H;
    return e === a;
  }
  function hr(e) {
    var n = [];
    if (e != null)
      for (var a in Object(e))
        n.push(a);
    return n;
  }
  function br(e) {
    return ve.call(e);
  }
  function yr(e, n, a) {
    return n = Ae(n === void 0 ? e.length - 1 : n, 0), function() {
      for (var c = arguments, d = -1, h = Ae(c.length - n, 0), m = Array(h); ++d < h; )
        m[d] = c[n + d];
      d = -1;
      for (var g = Array(n + 1); ++d < n; )
        g[d] = c[d];
      return g[n] = a(m), gt(e, this, g);
    };
  }
  function oe(e, n) {
    if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
      return e[n];
  }
  var mr = vr(rr);
  function vr(e) {
    var n = 0, a = 0;
    return function() {
      var c = St(), d = l - (c - a);
      if (a = c, d > 0) {
        if (++n >= i)
          return arguments[0];
      } else
        n = 0;
      return e.apply(void 0, arguments);
    };
  }
  function _r(e) {
    if (e != null) {
      try {
        return q.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function Y(e, n) {
    return e === n || e !== e && n !== n;
  }
  var ae = Se(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Se : function(e) {
    return D(e) && j.call(e, "callee") && !kt.call(e, "callee");
  }, se = Array.isArray;
  function ie(e) {
    return e != null && $e(e.length) && !le(e);
  }
  function wr(e) {
    return D(e) && ie(e);
  }
  var xe = It || Sr;
  function le(e) {
    if (!E(e))
      return !1;
    var n = W(e);
    return n == O || n == w || n == y || n == Ke;
  }
  function $e(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
  }
  function E(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  function D(e) {
    return e != null && typeof e == "object";
  }
  function Tr(e) {
    if (!D(e) || W(e) != de)
      return !1;
    var n = Te(e);
    if (n === null)
      return !0;
    var a = j.call(n, "constructor") && n.constructor;
    return typeof a == "function" && a instanceof a && q.call(a) == wt;
  }
  var Ee = ye ? bt(ye) : Qt;
  function kr(e) {
    return ir(e, Re(e));
  }
  function Re(e) {
    return ie(e) ? Wt(e) : Vt(e);
  }
  var Ar = lr(function(e, n, a, c) {
    Oe(e, n, a, c);
  });
  function Ir(e) {
    return function() {
      return e;
    };
  }
  function Pe(e) {
    return e;
  }
  function Sr() {
    return !1;
  }
  o.exports = Ar;
})(Q, Q.exports);
var An = Q.exports;
const In = /* @__PURE__ */ kn(An);
function Sn(o) {
  let r = {};
  function t(s, i) {
    if ((i == null ? void 0 : i.type) === "AwaitExpression" && i.argument.type === "CallExpression" && i.argument.callee.type === "Identifier" && i.argument.callee.name === "useStoryblok") {
      const l = i.argument.arguments;
      if (l && l[1].type === "ObjectExpression") {
        const u = He(l[1].properties);
        r = {
          ...r,
          apiOptions: u
        };
      }
      if (l && l[2].type === "ObjectExpression") {
        const u = He(l[2].properties);
        r = {
          ...r,
          bridgeOptions: u
        };
      }
    }
  }
  return In({}, o, t), r;
}
function He(o) {
  const r = {};
  return o.reduce((t, s) => {
    if (s.type !== "Property") return t;
    const { key: i, value: l } = s, { type: u } = l;
    if (i.type !== "Identifier") return t;
    if (u === "Literal")
      t[i.name] = l.value;
    else if (u === "ArrayExpression") {
      const f = l.elements.reduce((p, y) => y.type === "Literal" && y.value ? [...p, y.value] : p, []);
      t[i.name] = f;
    }
    return t;
  }, r);
}
let B = [];
function On(o, r) {
  const t = "virtual:storyblok-bridge", s = "\0" + t;
  if (!o || r !== "server")
    return {
      name: "vite-plugin-storyblok-bridge",
      resolveId(f) {
        if (f === t)
          return s;
      },
      load(f) {
        if (f === s)
          return "export const bridgeOptions = null";
      }
    };
  let i = [], l = null, u;
  return {
    name: "vite-plugin-storyblok-bridge",
    async resolveId(f) {
      if (f === t)
        return s;
    },
    async transform(f, p) {
      var O;
      if (p.includes("node_modules") && !p.includes("/pages/") || !f.includes("useStoryblok") || !((O = this.getModuleInfo(p).meta) != null && O.astro)) return;
      const [, ..._] = p.split("src/pages/"), k = _.join("/").replace(".astro", ""), A = Sn(this.parse(f));
      B.length && (i = B.filter((w) => w.url !== k)), i.push({
        url: k,
        options: A
      }), l && (u && clearTimeout(u), u = setTimeout(() => {
        Cn(B, i) || (B.length !== 0 && (l.restart(), console.info("Bridge options updated. Restarting...")), B = [...i]);
      }, 1e3));
    },
    async load(f) {
      if (f === s)
        return `export const bridgeOptions = ${JSON.stringify(Tn(i))}`;
    },
    configureServer(f) {
      l = f;
    }
  };
}
function Cn(o = [], r = []) {
  return r.every(({ url: t, options: s }) => {
    const i = o.find((l) => (l == null ? void 0 : l.url) === t);
    return i && JSON.stringify(s) === JSON.stringify(i.options);
  });
}
let qe;
async function Rn(o) {
  const { action: r, story: t } = o || {};
  if (r === "input" && t) {
    const s = async () => {
      const l = await xn(t), u = document.body;
      if (l.outerHTML === u.outerHTML) return;
      const f = document.querySelector('[data-blok-focused="true"]');
      jn(u, l, f);
    };
    clearTimeout(qe), qe = setTimeout(s, 500);
  }
  ["published", "change"].includes(o == null ? void 0 : o.action) && location.reload();
}
function jn(o, r, t) {
  if (t) {
    const s = t.getAttribute("data-blok-uid"), i = r.querySelector(
      `[data-blok-uid="${s}"]`
    );
    i && (i.setAttribute("data-blok-focused", "true"), t.replaceWith(i));
  } else
    o.replaceWith(r);
}
async function xn(o) {
  const t = await (await fetch(location.href, {
    method: "POST",
    body: JSON.stringify({
      ...o,
      is_storyblok_preview: !0
    }),
    headers: {
      "Content-Type": "application/json"
    }
  })).text();
  return new DOMParser().parseFromString(t, "text/html").body;
}
function Pn() {
  return globalThis.storyblokApiInstance || console.error("storyblokApiInstance has not been initialized correctly"), globalThis.storyblokApiInstance;
}
async function Mn(o, r = {}, t = {}, s) {
  globalThis.storyblokApiInstance || console.error("storyblokApiInstance has not been initialized correctly");
  let i = null;
  if (s && s.locals._storyblok_preview_data)
    i = s.locals._storyblok_preview_data;
  else {
    const { data: l } = await globalThis.storyblokApiInstance.get(
      o,
      r,
      t
    );
    i = l.story;
  }
  return i;
}
function Nn(o, r) {
  const t = globalThis.storyblokApiInstance.richTextResolver;
  if (!t) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return wn(o, r, t);
}
function zn(o) {
  const r = {
    useCustomApi: !1,
    bridge: !0,
    componentsDir: "src",
    enableFallbackComponent: !1,
    livePreview: !1,
    ...o
  };
  return {
    name: "@storyblok/astro",
    hooks: {
      "astro:config:setup": ({
        injectScript: t,
        updateConfig: s,
        addDevToolbarApp: i,
        addMiddleware: l,
        config: u
      }) => {
        if (s({
          vite: {
            plugins: [
              Or(
                r.accessToken,
                r.useCustomApi,
                r.apiOptions
              ),
              Pr(
                r.componentsDir,
                r.components,
                r.enableFallbackComponent,
                r.customFallbackComponent
              ),
              Mr(r),
              On(
                r.livePreview,
                u.output
              )
            ]
          }
        }), r.livePreview && (u == null ? void 0 : u.output) !== "server")
          throw new Error(
            "To utilize the Astro Storyblok Live feature, Astro must be configured to run in SSR mode. Please disable this feature or switch Astro to SSR mode."
          );
        if (t(
          "page-ssr",
          `
          import { storyblokApiInstance } from "virtual:storyblok-init";
          globalThis.storyblokApiInstance = storyblokApiInstance;
          `
        ), r.bridge && !r.livePreview) {
          let f = "";
          if (typeof r.bridge == "object") {
            const p = { ...r.bridge };
            f = `const storyblokInstance = new StoryblokBridge(${JSON.stringify(
              p
            )});`;
          } else
            f = "const storyblokInstance = new StoryblokBridge()";
          t(
            "page",
            `
              import { loadStoryblokBridge } from "@storyblok/astro";
              loadStoryblokBridge().then(() => {
                const { StoryblokBridge, location } = window;
                ${f}

                storyblokInstance.on(["published", "change"], (event) => {
                  if (!event.slugChanged) {
                    location.reload(true);
                  } 
                });
              });
            `
          );
        }
        r.livePreview && (t(
          "page",
          `
              import { loadStoryblokBridge, handleStoryblokMessage } from "@storyblok/astro";
              import { bridgeOptions }  from "virtual:storyblok-bridge";
              console.info("The Storyblok Astro live preview feature is currently in an experimental phase, and its API is subject to change in the future.")
              loadStoryblokBridge().then(() => {
                const { StoryblokBridge, location } = window;
                if(bridgeOptions){
                  const storyblokInstance = new StoryblokBridge(bridgeOptions);
                  storyblokInstance.on(["published", "change", "input"], handleStoryblokMessage);
                };
              });
            `
        ), l({
          entrypoint: "@storyblok/astro/middleware.ts",
          order: "pre"
        })), i("@storyblok/astro/toolbarApp.ts");
      }
    }
  };
}
export {
  bn as RichTextResolver,
  pn as RichTextSchema,
  zn as default,
  Rn as handleStoryblokMessage,
  En as loadStoryblokBridge,
  Nn as renderRichText,
  $n as storyblokEditable,
  Mn as useStoryblok,
  Pn as useStoryblokApi
};
